export const TOURS = [
  {
    id: "1",
    name: "Swiss Alps Panorama",
    destination: "Swiss Alps",
    duration: "3 days",
    price: 349,
    image: "https://images.unsplash.com/photo-1589223050279-18d1f14059cf?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Alpine meadows, glacier viewpoints and charming mountain villages.",
    images: [
      "https://images.unsplash.com/photo-1521292270410-a8c4d716d518?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1617256955938-598efba0ea5e?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1517079810336-d39e72287591?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    id: "2",
    name: "Interlaken Adventure",
    destination: "Interlaken",
    duration: "2 days",
    price: 249,
    image: "https://images.unsplash.com/photo-1506351487281-fd19470d8bf4?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Two emerald lakes, adventure sports and the gateway to the Jungfrau.",
    images: [
      "https://images.unsplash.com/photo-1605825856823-cabe105ab0af?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1612215864092-355d4b25083f?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1571784157310-23547fa255c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    id: "3",
    name: "Zermatt & Matterhorn",
    destination: "Zermatt",
    duration: "2 days",
    price: 299,
    image: "https://images.unsplash.com/photo-1571274834067-3a24675547b4?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Car-free alpine streets beneath the world's most famous peak.",
    images: [
      "https://images.unsplash.com/photo-1507039102241-5ec61d624406?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1636232608972-426a145d3752?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1605750454112-f2f3f696eeb0?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    id: "4",
    name: "Lucerne Old Town & Lake",
    destination: "Lucerne",
    duration: "1 day",
    price: 129,
    image: "https://images.unsplash.com/photo-1663782196173-5a6874125665?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Chapel Bridge, medieval lanes and a lake cruise at golden hour.",
    images: [
      "https://images.unsplash.com/photo-1518079521743-d5f88b127929?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1477271706509-fecda7438b68?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1684871640048-f298aaa8b03c?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    id: "5",
    name: "Zurich City & Lake",
    destination: "Zurich",
    duration: "1 day",
    price: 99,
    image: "https://images.unsplash.com/photo-1515488764276-beab7607c1e6?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Old-town charm, Bahnhofstrasse and lakeside promenades.",
    images: [
      "https://images.unsplash.com/photo-1620563092215-0fbc6b55cfc5?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1643981670720-eef07ebdb179?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1657137436880-e906b111b040?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  {
    id: "6",
    name: "Geneva & Jet d'Eau",
    destination: "Geneva",
    duration: "2 days",
    price: 279,
    image: "https://images.unsplash.com/photo-1633022326182-1b36700bc49a?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Lakeside elegance, the old town and views towards Mont Blanc.",
    images: [
      "https://images.unsplash.com/photo-1584200463394-bba4b2117e4d?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1597131133917-a4f964b59f4c?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1660810534344-28d90fd0e199?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
];

export const DESTINATIONS = [
  { name: "Swiss Alps", tagline: "Peaks, passes & panoramic trails", image: TOURS[0].image },
  { name: "Interlaken", tagline: "Adventure between two lakes", image: TOURS[1].image },
  { name: "Zermatt", tagline: "Home of the Matterhorn", image: TOURS[2].image },
  { name: "Lucerne", tagline: "Medieval charm on the water", image: TOURS[3].image },
  { name: "Zurich", tagline: "Culture, cuisine & the lake", image: TOURS[4].image },
  { name: "Geneva", tagline: "Riviera spirit beneath Mont Blanc", image: TOURS[5].image },
];
